import React from 'react';
import { Check } from 'lucide-react';
import { aboutData } from '../mock';

export const About = () => {
  return (
    <section id="about" className="relative py-24 bg-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <div className="inline-block">
                <span className="text-sm tracking-[0.3em] uppercase text-gray-500 font-light">
                  About Us
                </span>
                <div className="h-px w-16 bg-gray-900 mt-2" />
              </div>
            </div>

            <h2 className="text-4xl lg:text-5xl font-light text-gray-900 leading-tight">
              {aboutData.title}
            </h2>

            <p className="text-lg text-gray-600 leading-relaxed">
              {aboutData.description}
            </p>

            {/* Expertise Grid */}
            <div className="grid gap-4 pt-6">
              {aboutData.expertise.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 group"
                >
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-900 flex items-center justify-center mt-1 group-hover:scale-110 transition-transform duration-300">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-gray-700 text-base">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1652366643487-a432187cbff8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwYWx1bWluaXVtJTIwd2luZG93fGVufDB8fHx8MTc2NTI3ODkyOHww&ixlib=rb-4.1.0&q=85"
                alt="Architectural Detail"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent" />
            </div>

            {/* Floating Stats */}
            <div className="absolute -bottom-8 -left-8 bg-white p-8 rounded-lg shadow-xl border border-gray-100">
              <div className="text-5xl font-light text-gray-900 mb-2">20+</div>
              <div className="text-sm tracking-wider uppercase text-gray-600">Years Experience</div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border border-gray-900/10 rounded-lg" />
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border border-gray-900/5 rounded-lg" />
          </div>
        </div>
      </div>
    </section>
  );
};